import script from "./Navigation.vue?vue&type=script&setup=true&lang=js"
export * from "./Navigation.vue?vue&type=script&setup=true&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=bb444032&lang=postcss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb444032"]])

export default __exports__